<template>
  <div>
    <MainPage v-if="loaded">
      <v-layout class="grid-links" wrap>
        <v-flex class="grid-link grid-link-left" xs12 sm12 md6 lg6>
          <router-link
            to="/raffle-silent-auction"
            class="grid-link__content grid-link---preview1"
          >
            <div class="grid-link__title">Thanks for Your Help!</div>
            <div class="grid-link__description">
              Our Golf Ball attendees earned some amazing prizes by making a
              contribution. There’s still time for you to make your mark on East
              Lake.
            </div>
          </router-link>
        </v-flex>
        <v-flex xs12 sm12 md6 lg6>
          <v-layout wrap>
            <v-flex xs12 class="grid-link grid-link-left">
              <router-link
                to="/stories"
                class="grid-link__content grid-link---preview2"
              >
                <div class="grid-link__title">
                  Share a Memory
                </div>
                <div class="grid-link__description">
                  Made the trip to East Lake before? Show off your favorite
                  memories.
                </div>
              </router-link>
            </v-flex>
            <v-flex xs12 class="grid-link grid-link-left">
              <router-link
                to="/our-impact"
                class="grid-link__content grid-link---preview3"
              >
                <div class="grid-link__title">PGA TOUR Impact</div>
                <div class="grid-link__description">
                  Learn more about how the PGA TOUR supports the life-changing
                  work of the East Lake Foundation, Grove Park Foundation,
                  Purpose Built Schools Atlanta, and more.
                </div>
              </router-link>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </MainPage>
    <div class="seeall-wrapper">
      <v-btn
        class="seeall-btn"
        href="https://e.givesmart.com/events/isQ/i/"
        target="_blank"
        large
        elevation="0"
        color="primary"
        outlined
        >See All Items</v-btn
      >
    </div>
    <Sponsors />
    <div class="iu-badge">
      <div class="iu-badge__text">
        Special thanks to our partners at Ideas United for hosting the TOUR
        Championship Golf Ball on
        <a href="https://ideasunited.com/commons" target="_blank">Commons</a>.
      </div>
      <a
        class="iu-badge__logo"
        href="http://ideasunited.com/"
        target="_blank"
      ></a>
    </div>
    <div class="social-aggragator">
      <h1 class="social-aggragator__title">
        Enjoying the GOLF Ball?
      </h1>
      <p class="social-aggragator__intro">
        Share a photo or follow the action with #TOURCHAMPIONSHIP
      </p>
      <div class="flockler-wrapper">
        <div id="flockler-embed-1740738048b0a3c4fd25ca4e1ccf5296"></div>
      </div>
    </div>
  </div>
</template>

<script>
import MainPage from "./main.page";

export default {
  name: "HomePage",
  components: { MainPage },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    this.setPageContext("home", () => {
      this.loaded = true;
    });
    let flocklerScript = document.createElement("script");
    flocklerScript.setAttribute(
      "src",
      "https://plugins.flockler.com/embed/17306b20f4806af0ee967ed6c0e66236/1740738048b0a3c4fd25ca4e1ccf5296"
    );
    document.head.appendChild(flocklerScript);
  },
};
</script>

<style scoped lang="scss">
.social-aggragator {
  margin: 40px;
  color: #676767;
  text-align: center;
  &__title {
    font-family: "Roboto Condensed";
    font-weight: 300;
    font-size: 36px;
    line-height: 40px;
    letter-spacing: -0.01em;
    text-transform: uppercase;
  }
  &__intro {
    font-size: 18px;
    line-height: 22px;
    border-bottom: 2px solid #e80000;
    padding: 0.5em 0;
  }
  .flockler-wall-item {
    &__content {
      border: none !important;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15) !important;
    }
    &__body {
      font-size: 18px;
      line-height: 22px;
    }
  }
  .flockler-btn-load-more {
    color: $primary;
    background-color: white;
    border: 2px solid $primary;
  }
}
.flockler-posts:not(.flockler-grid-items) a.flockler-btn-load-more {
  color: $primary;
  background-color: white;
  border: 2px solid $primary;
  &:hover {
    color: $primary;
    background-color: white;
    border: 2px solid $primary;
  }
}

.iu-badge a {
  color: black;
}
.iu-badge {
  text-decoration: none;
  color: black;
  display: flex;
  margin: 0 30px 50px 30px;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  &__text {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 300;
    font-size: 32px;
    line-height: 1.03;
    text-transform: uppercase;
    flex-basis: 68%;
  }
  &__logo {
    flex-basis: 24%;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("~@/assets/iu_logo.png");
    &::before {
      content: "";
      display: block;
      width: 100%;
      padding-bottom: 27%;
    }
  }
}

.seeall-wrapper {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 1264px) {
  a.iu-badge {
    margin: 40px;
  }
}
@media screen and (max-width: 800px) {
  .iu-badge {
    margin: 20px;
    flex-direction: column;
    &__logo {
      width: 50vw;
      margin-top: 5vw;
    }
  }

  .v-btn.seeall-btn {
    font-size: 15px !important;
    padding: 0 20px !important;
  }
  .social-aggragator {
    text-align: left;
    &__title {
      font-size: 24px;
      line-height: 28px;
    }
    &__intro {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
